import logo from "assets/images/logo.webp";

const Logo = () => {
  return <img src={logo} className="App-logo" alt="logo" width="40px" />;
};

export default Logo;
